var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Star = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M11.9994 18.1277L16.0789 20.3674C16.8732 20.8031 17.8008 20.0986 17.6492 19.1753L16.8701 14.4302L20.1716 11.0716C20.8144 10.4171 20.4604 9.27707 19.5715 9.14213L15.0109 8.44939L12.9717 4.13033C12.575 3.28989 11.4268 3.28989 11.0301 4.13033L8.98984 8.44939L4.42826 9.14213C3.54036 9.27707 3.1854 10.4171 3.82819 11.0716L7.12961 14.4302L6.35053 19.1753C6.19899 20.0986 7.12656 20.8041 7.9209 20.3674L12.0004 18.1277", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
